import ApiService from './ApiService';

// Analytics are fire-and-forget: no caller waits on these requests, and a
// failure must not break the page. Without the catch, an expired session (401)
// or a Customer.io outage (500) becomes an unhandled promise rejection that is
// reported to Sentry. GO4ELLIS-BACKEND-4F3, GO4ELLIS-BACKEND-STAGING-23X
const ignoreFailure = () => null;

class TrackingService extends ApiService {
  constructor(session) {
    super(session);
    this.url = '/tracking';
  }

  track = (event) => {
    return super.post(this.url + '.json', event, (response) => response).catch(ignoreFailure);
  };

  trackMixpanel = (event) => {
    return super
      .post(this.url + '/mixpanel.json', event, (response) => response)
      .catch(ignoreFailure);
  };
}

export default TrackingService;
